if(!customElements.get('collection-variant')) {
    class ComponentCollectionVariants extends HTMLElement {
        constructor() {
            super();
            this.quickViewBtn = this.querySelector('.quick-view-trigger');
            this.data = JSON.parse(this.querySelector(".product-json").textContent);
            this.product = this.data.product;
            this.collection = this.data.collection;

            console.log(this.product);

            if (this.quickViewBtn) {
                this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
            }
        }

        openQuickView(e) {
          e.preventDefault();
        }
    }
    customElements.define('collection-variant', ComponentCollectionVariants);
 }